export default "__VITE_ASSET__C$ZIgk5T__"